import React from "react";
import InboxIcon from "@mui/icons-material/Inbox";

interface NoDataFoundProps {
  colSpan: number;
  message?: string;
  subtitle?: string;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  colSpan,
  message = "No Data Found",
  subtitle = "Try adjusting your filters or search criteria",
}) => {
  return (
    <tr>
      <td
        colSpan={colSpan}
        style={{
          textAlign: "center",
          padding: "60px 20px",
          verticalAlign: "middle",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <InboxIcon
            style={{
              fontSize: "64px",
              color: "#9e9e9e",
              opacity: 0.6,
            }}
          />
          <div
            style={{
              fontSize: "16px",
              fontWeight: 500,
              color: "#616161",
              letterSpacing: "0.5px",
            }}
          >
            {message}
          </div>
          {subtitle && (
            <div
              style={{
                fontSize: "14px",
                color: "#9e9e9e",
                marginTop: "4px",
              }}
            >
              {subtitle}
            </div>
          )}
        </div>
      </td>
    </tr>
  );
};

export default NoDataFound;

